import React, { CSSProperties, ChangeEvent } from 'react';

interface CheckboxProps {
  label?: string;
  id?: string;
  customStyle?: CSSProperties;
  onChange: (checked: boolean) => void;
  name?: string;
  required?: boolean;
  checked?: boolean;
  testId?: string;
}

export default function Checkbox({
  label,
  id,
  customStyle,
  onChange,
  name,
  required,
  checked,
  testId,
}: CheckboxProps) {
  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <div style={customStyle}>
      <input
        type="checkbox"
        onChange={handleCheckboxChange}
        id={id}
        name={name}
        required={required}
        checked={checked}
        data-testid={testId || "checkbox-input-testid"}
      />
      {label && <label htmlFor={id}>{ label }</label>}
    </div>
  );
}
